import React, {useState} from 'react';
import './App.css';
import {isIE} from 'react-device-detect';
import Loader from 'react-loader-spinner';
import Modal from './elements/Modal';
import IE from './pages/IE';
import MainWindow from './main'; 
import {
  BrowserRouter as Router,
  Route
} from "react-router-dom";
import { useCallback, useEffect } from 'react';
import {useDispatch} from 'react-redux';
import { login_success, request_logout } from './redux/actions';
import PrivateRoute from './utils/PrivateRoute';
import ConfirmationModal from './elements/ConfirmationModal';
import checkTokenValidity from './helpers/checkTokenValidity';



function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const userData = localStorage.getItem("user_data");
    
    if(userData){
      const token = localStorage.getItem("token");
      if(checkTokenValidity(token)){
        dispatch(login_success(JSON.parse(userData)));
      }else{
        dispatch(request_logout);
      }
      
    }
    setLoading(false)
  },[]);

  if(isIE){

    //just checking if it's Internet Explorer, we don't do Internet Explorer
    return IE
  } else {
    if(loading){
      return(
        <Loader
            type='TailSpin'
            color='#0dafd0ff'
            height='40'
            width='40'
        
        />
      )
    }else{
      return(
        <Router basename='/app'>
          <Route path='/' render={(location)=><MainWindow location={location}/>} />
          <Route path='/filtro' render={() =><ConfirmationModal tipo='filtrar'/>} />
          <PrivateRoute path='/novo-avistamento-gaivota' component={Modal} tipo={'avistamento'} titulo={'Reportar gaivota'} />
          <PrivateRoute path='/novo-avistamento-ninho' component={Modal} tipo={'aninhamento'} titulo={'Reportar ninho'} />
          <PrivateRoute path='/novo-ataque' component={Modal} tipo={'ataque'} titulo={'Reportar ataque'} />
          <PrivateRoute path='/minha-conta' component={Modal} tipo={'conta'} titulo={'Minha conta'} />
          <PrivateRoute path='/minha-conta/editar-avatar' component={ConfirmationModal} tipo={'editAvatar'} />
          <PrivateRoute path='/validar' component={Modal} tipo={'validar'} titulo={'Validar'} />
          <PrivateRoute path='/admin' component={Modal} tipo={'admin'} titulo={'Administração'} />
          <PrivateRoute path='/admin/utilizador' component={Modal} tipo={'admin-user'} titulo={'Administração'}/>
          <PrivateRoute path='/validar/validar_detalhes' component={ConfirmationModal} tipo={'validar'} />
          <PrivateRoute path='*/confirmar' component={ConfirmationModal} tipo={'delete'} />
          <PrivateRoute path='/minha-conta/alterar-password' component={ConfirmationModal} tipo={'novaPassword'} />
          <Route path='/login' render={() => <Modal tipo={'login'} titulo={'Entrar'}/>} />
          <Route path='/reposicao/:id/:token' render={() => <Modal tipo={'reset'} titulo={'Repor password'}/>} />
        </Router>
        
      )
    }
    
      
  }
}

export default App;
